import { render } from "./distributionManage.vue?vue&type=template&id=89d706e8&scoped=true&ts=true"
import script from "./distributionManage.vue?vue&type=script&lang=ts"
export * from "./distributionManage.vue?vue&type=script&lang=ts"

import "./distributionManage.vue?vue&type=style&index=0&id=89d706e8&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89d706e8"]])

export default __exports__